import * as yup from 'yup';

import { TransactionItem } from '@clients/transactionsClient';
import { VisaListOfModalityOptionsRequiringReasons } from '@datasets/Modality';

export const reportDisputeDialogSchema = (transaction: TransactionItem) =>
    yup.object({
        modality: yup.string().required('CREATE_DISPUTE_FORM_MODALITY'),
        dispute_due_to: yup.string().when('modality', {
            is: (modality: string) =>
                VisaListOfModalityOptionsRequiringReasons.includes(modality),
            then: yup.string().required('CREATE_DISPUTE_FORM_DISPUTE_DUE_TO'),
        }),
        arn:
            transaction?.authorization?.id != null
                ? yup.string()
                : yup.string().required('CREATE_DISPUTE_FORM_ARN'),
        comment: yup.string(),
    });

export default reportDisputeDialogSchema;
